import {IComponentOptions} from "angular";
import ApplicationController from "../../shared/application/application.controller";
import "./assess-application.less";

export const AssessApplicationComponent: IComponentOptions = {
    bindings: {
        application: "<",
        applicationCourseOfferStatus: "<",
        applicationHistories: "<",
        assessments: "<",
        currentUser: "<",
        currentCourses: "<",
        previousApplications: "<",
        approvedAssessmentsCreditSummary: "<"
    },
    controller: ApplicationController,
    template: require("./assess-application.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/application/assess-application.component.ts